// Italian-locale formatters. Centralized so the same euro display + date
// style appears everywhere — the prototype's "50,30 €/mese" and "Martedì
// 5 maggio" are brand voice elements, not just locale conventions.

const EUR = new Intl.NumberFormat("it-IT", {
  style: "currency",
  currency: "EUR",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const DATE_LONG = new Intl.DateTimeFormat("it-IT", {
  weekday: "long",
  day: "numeric",
  month: "long",
});

const DATE_SHORT = new Intl.DateTimeFormat("it-IT", {
  day: "numeric",
  month: "long",
});

/** "50,30 €" — Italian decimal comma, currency suffix. */
export function formatEur(amount: number): string {
  // Default Italian Intl output is "50,30 €" — exactly the prototype's
  // spacing. Pass through unchanged.
  return EUR.format(amount);
}

/** "Martedì 5 maggio" — capitalised weekday, brand voice. */
export function formatDateLong(value: Date | string | number): string {
  const d = value instanceof Date ? value : new Date(value);
  const out = DATE_LONG.format(d);
  // Intl defaults to lowercase weekday in Italian; the prototype capitalises.
  return out.charAt(0).toUpperCase() + out.slice(1);
}

/** "22 marzo" — used in conversation history rows. */
export function formatDateShort(value: Date | string | number): string {
  const d = value instanceof Date ? value : new Date(value);
  return DATE_SHORT.format(d);
}
